import { addresses, } from "./addresses";
import type { ITokenDefinition, } from "./types/interfaces";

export const getContractDefinitions = () => {
	return addresses.filter(address => address.implements.includes("IContractDefinition"));
}

export const getTokenDefinitions = () => {
	return addresses.filter(address => address.implements.includes("ITokenDefinition"));
}

export const getTokenDefinition = ( identifier: string ): ITokenDefinition => {
	const contract = addresses.find(contract => contract.symbol === identifier || contract.name === identifier || contract.address.toLowerCase() === identifier.toLowerCase());
	if(contract) {
		return contract as ITokenDefinition;
	}
	throw new Error(`Token definition not found for identifier ${identifier}`);
}
